import * as actionTypes from "../actions/actionTypes";
import axios from "axios";

const msgFetching = () => {
	return {
		type: actionTypes.MESSAGE_FETCHING,
	};
};

const msgFetchedSuccessfully = (msgs) => {
	// console.log(msgs);
	return {
		type: actionTypes.MESSAGE_FETCHING_SUCCESSFULLY,
		msgs: msgs,
	};
};

export const initiateMsgFetching = (userId) => {
	return (dispatch) => {
		dispatch(msgFetching());
		const tempMsgs = [];
		axios
			.get(`https://muzammil3797.firebaseio.com/messages.json?auth=${userId}`)
			.then((res) => {
				for (let key in res.data) {
					tempMsgs.push({ id: key, ...res.data[key] });
				}
				dispatch(msgFetchedSuccessfully(tempMsgs));
			})
			.catch((err) => err);
	};
};

const msgDeleting = () => {
	return {
		type: actionTypes.MESSAGE_DELETING,
	};
};

const msgDeletedSuccessfully = (id) => {
	// console.log(id);
	return {
		type: actionTypes.MESSAGE_DELETING_SUCCESSFULLY,
		id: id,
	};
};

export const initiateMsgDeleting = (id) => {
	// console.log(id);
	return (dispatch) => {
		dispatch(msgDeleting());
		axios
			.delete(`https://muzammil3797.firebaseio.com/messages/${id}.json`)
			.then((res) => {
				// console.log(res);
				dispatch(msgDeletedSuccessfully(id));
			})
			.catch((err) => {});
	};
};
